import { AssetType, OnboardingFulfilledBy, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { ApplicationTypeMap } from '@/config/maps/ApplicationType.map';
import { ApplicationType } from '@/config/types';

export const getApplicationTypes = ({
  assetTypes,
  onboardingFulfilledBys,
  allowedPaymentMethods,
}: {
  assetTypes: AssetType[];
  onboardingFulfilledBys: OnboardingFulfilledBy[];
  allowedPaymentMethods?: PaymentMethodType[];
}): ApplicationType[] => {
  if (!assetTypes) return [];

  const applicationTypes = [] as ApplicationType[];

  const aggregateAssetTypesDefaults = () => {
    assetTypes.map((assetType) => {
      const productOfAssetType = ApplicationTypeMap.fromAssetType(assetType);
      if (productOfAssetType) {
        if (!applicationTypes.includes(productOfAssetType)) {
          applicationTypes.push(productOfAssetType);
        }
      }
    });
  };

  const recalculateByOnboardingFulfilledBy = () => {
    const orderIndex = applicationTypes.findIndex((prod) => prod === ApplicationType.ORDER);
    const hasOrder = orderIndex !== -1;
    if (hasOrder) {
      applicationTypes.splice(orderIndex, 1);
      onboardingFulfilledBys.forEach((fulfilledBy) => {
        const newApplicationType = ApplicationTypeMap.recalculateOrderByOnboardingFulfilledBy(fulfilledBy);
        if (newApplicationType) {
          applicationTypes.push(newApplicationType);
        }
      });
    }
  };

  const addSinglePaymentApplicationTypes = () => {
    if (!allowedPaymentMethods) return;
    if (allowedPaymentMethods.includes(PaymentMethodType.A2A_PAYMENT)) {
      applicationTypes.push(ApplicationType.A2A_PAYMENT);
    }
    if (allowedPaymentMethods.includes(PaymentMethodType.CARD_PAYMENT)) {
      applicationTypes.push(ApplicationType.CARD_PAYMENT);
    }
  };

  aggregateAssetTypesDefaults();
  recalculateByOnboardingFulfilledBy();
  addSinglePaymentApplicationTypes();
  return applicationTypes;
};
